/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'reaction-neutral': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs><path pid="0" d="M10 0C4.489 0 0 4.489 0 10s4.489 10 10 10 10-4.489 10-10S15.511 0 10 0zm0 2c4.43 0 8 3.57 8 8s-3.57 8-8 8-8-3.57-8-8 3.57-8 8-8zM7 7a1 1 0 100 2 1 1 0 000-2zm6 0a1 1 0 100 2 1 1 0 000-2zm-7 6a1 1 0 001 1h6a1 1 0 000-2H7a1 1 0 00-1 1z" id="svgicon_reaction-neutral_a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_reaction-neutral_b" _fill="#fff"><use xlink:href="#svgicon_reaction-neutral_a"/></mask><path pid="1" _fill="#22262A" fill-rule="nonzero" mask="url(#svgicon_reaction-neutral_b)" d="M-2-2h24v24H-2z"/></g>'
  }
})
